import { mapPrice, mapReducedPrice } from "./price";
import { mapBadgeType } from "./mapBadge";

export const mapProducts = products =>
  products.map(product => {
    const price = mapPrice(product.price);

    return {
      id: product.id,
      url: product.url,
      price: price.value,
      description: product.name,
      image: product.imageUrl,
      badgeType: mapBadgeType(product),
      productType: product.productType,
      colourWayId: product.colourWayId,
      isSale: product.price.isMarkedDown,
      reducedPrice: mapReducedPrice(product.price),
      hasMultiplePrices: product.hasMultiplePrices,
      isOutlet: product.price.isOutletPrice
    };
  });
